export const decisionAwardResolution = 'decisionAwardResolution';
export const decisionContractResolution = 'decisionContractResolution';

export const decisionCardResolution = 'decisionCardResolution';
export const decisionSummitDraft = 'decisionSummitDraft';
export const decisionSummitWinter = 'decisionSummitWinter';
export const decisionTurnOrder = 'decisionTurnOrder';

export const normalSeasonalTurn = 'normalSeasonalTurn';

export const summitResolution = 'summitResolution';
